<template>
  <!-- FIXME: adminプレビューの際matchHeightがうまく効かないため要修正(クリック領域ではないため優先度低) -->
  <div
    class="card p-4"
    :class="{ 'company-detail-case-study-card' : isCompanyDetail }"
    data-mh="case-study-simple-card"
  >
    <div
      class="card-body"
    >
      <div class="case-study-card-content">
				<span class="industry-tag-chip d-inline-block mb-2 px-3 font-small">
					{{ industryTag }}
				</span>
				<div class="font-middle font-weight-bold mb-3">
					{{ publicName }}
				</div>
        <inline-tags-list class="mb-n2" :tags-array="tags" />
      </div>
    </div>
  </div>
</template>

<script>
import InlineTagsList from "../companies/InlineTagsList.vue";

export default {
  components: { InlineTagsList },
  props: {
    industryTag: {
      type: String,
      default: ""
    },
    publicName: {
      type: String,
      default: ""
    },
    tags: {
      type: Array,
      default() {
        return [];
      }
    },
    isCompanyDetail: {
      type: Boolean,
      default: false
    }
  }
};
</script>

<style lang="scss" scoped>
.card {
  transition: 0.5s;
  &:hover {
    box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.15);

    img {
      opacity: 1;
    }
  }

  .card-title {
    width: 100%;
    border-radius: 3px 3px 0 0;
  }

  .card-body {
    // 事例詳細ページ内企業詳細 事例カードの「実施内容」背景色
		color: #282828;
    padding: 0;
    .chip {
      cursor: pointer !important;
    }
    .industry-tag-chip {
      color: #33b88b;
      padding-top: 3px;
      padding-bottom: 3px;
      border: 1px solid #33b88b;
      border-radius: 30px;
    }
  }
}

.company-detail-case-study-card {
  @media (min-width: 1200px) {
    min-height: 209px;
    padding: 2rem !important;
  }
  @media (max-width: 1199px) {
    min-height: 219px;
  }
  @media (max-width: 767px) {
    min-height: 194px;
  }
}
</style>
